(() => {
  if (customElements.get('ea-wishlist')) return;
  class EarthlyWishlist extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.text = JSON.parse(this.querySelector('[data-ea-wish-strings]').textContent);
      this.root = this.dataset.root || '/';
      this.key = 'earthly.saved-pieces.v1';
      this.items = this.read();
      this.dialog = this.querySelector('dialog');
      this.content = this.querySelector('[data-wish-content]');
      this.toast = this.querySelector('.ea-wish-toast');
      this.products = new Map();
      this.removed = null;
      this.generation = 0;
      document.addEventListener('click', event => {
        const save = event.target.closest('[data-ea-wish-save]');
        if (save) { event.preventDefault(); event.stopPropagation(); this.toggle(save); return; }
        const open = event.target.closest('[data-ea-wish-open]');
        if (open) { event.preventDefault(); this.open(open); }
      });
      this.addEventListener('click', event => this.click(event));
      this.addEventListener('change', event => {
        if (event.target.matches('[data-wish-select]')) this.select(event.target);
      });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.close(); });
      window.addEventListener('storage', event => {
        if (event.key !== this.key && event.key !== null) return;
        this.items = this.read(); this.sync();
        if (this.dialog.open) this.render();
      });
      window.addEventListener('pageshow', () => { this.items = this.read(); this.sync(); });
      document.addEventListener('shopify:section:load', () => this.sync());
      let queued = false;
      this.observer = new MutationObserver(records => {
        if (queued || !records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('[data-ea-wish-save]') || n.querySelector?.('[data-ea-wish-save]'))))) return;
        queued = true; requestAnimationFrame(() => { queued = false; this.sync(); });
      });
      this.observer.observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
      this.sync();
    }
    read() {
      try {
        const value = JSON.parse(localStorage.getItem(this.key) || '[]');
        return Array.isArray(value) ? [...new Set(value.filter(h => typeof h === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(h)))] : [];
      } catch (_) { return this.items || []; }
    }
    persist() {
      try { localStorage.setItem(this.key, JSON.stringify(this.items)); this.temporary = false; }
      catch (_) { this.temporary = true; }
      this.querySelector('[data-wish-note]').textContent = this.text[this.temporary ? 'session_note' : 'note'];
      this.sync();
    }
    sync() {
      document.querySelectorAll('[data-ea-wish-save]').forEach(button => {
        const saved = this.items.includes(button.dataset.eaWishSave);
        button.setAttribute('aria-pressed', String(saved));
        button.setAttribute('aria-label', `${this.text[saved ? 'remove_label' : 'save']}: ${button.dataset.productTitle || ''}`);
        const label = button.querySelector('[data-ea-wish-label]');
        if (label) label.textContent = this.text[saved ? 'saved' : 'save'];
      });
      document.querySelectorAll('[data-ea-wish-count]').forEach(count => {
        count.hidden = !this.items.length; count.textContent = this.items.length;
      });
      document.querySelectorAll('[data-ea-wish-open]').forEach(button => button.setAttribute('aria-label', `${this.text.open} (${this.items.length})`));
      this.querySelector('[data-wish-summary]').textContent = this.items.length === 1 ? this.text.one : this.text.many.replace('__COUNT__',this.items.length);
    }
    toggle(button) {
      const handle = button.dataset.eaWishSave;
      if (!/^[a-z0-9][a-z0-9-]*$/.test(handle)) return;
      if (this.items.includes(handle)) this.remove(handle);
      else {
        this.items.unshift(handle); this.persist();
        button.classList.remove('is-loved'); requestAnimationFrame(() => button.classList.add('is-loved'));
        this.notify(this.text.saved, this.text.view, () => this.open(button));
        if (this.dialog.open) this.render();
      }
    }
    remove(handle) {
      const index = this.items.indexOf(handle);
      if (index < 0) return;
      this.items.splice(index,1); this.persist();
      const row = [...this.content.children].find(el => el.dataset.handle === handle);
      const nextFocus = row?.nextElementSibling?.querySelector('button') || row?.previousElementSibling?.querySelector('button');
      row?.remove();
      if (!this.items.length && this.dialog.open) this.render();
      if (this.dialog.open) (nextFocus || this.querySelector('[data-wish-close]')).focus();
      this.notify(this.text.removed,this.text.undo,() => {
        if (!this.items.includes(handle)) { this.items.splice(Math.min(index,this.items.length),0,handle); this.persist(); if(this.dialog.open) this.render(); }
      });
    }
    notify(message, action, callback) {
      clearTimeout(this.toastTimer);
      this.toast.hidden = false;
      this.toast.querySelector('[data-wish-toast-text]').textContent = message;
      const button = this.toast.querySelector('[data-wish-toast-action]');
      button.textContent = action || ''; button.hidden = !action; this.toastAction = callback;
      if (this.dialog.open) this.dialog.querySelector('.ea-wish-shell').append(this.toast);
      else this.append(this.toast);
      this.toastTimer = setTimeout(() => { this.toast.hidden = true; },6500);
    }
    open(trigger) {
      if (this.dialog.open) return;
      this.trigger = trigger; this.toast.hidden = true;
      this.lock = {y:window.scrollY,position:document.body.style.position,top:document.body.style.top,width:document.body.style.width,overflow:document.body.style.overflow};
      document.body.style.position='fixed'; document.body.style.top=`-${this.lock.y}px`; document.body.style.width='100%'; document.body.style.overflow='hidden';
      this.dialog.showModal();
      this.querySelector('[data-wish-close]').focus({preventScroll:true});
      this.render();
    }
    close() {
      if (!this.dialog.open) return;
      this.dialog.close(); this.generation++;
      const lock=this.lock;
      if(lock) { document.body.style.position=lock.position;document.body.style.top=lock.top;document.body.style.width=lock.width;document.body.style.overflow=lock.overflow;window.scrollTo({top:lock.y,behavior:'instant'});this.lock=null; }
      this.toast.hidden=true; this.append(this.toast);
      if(this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
    }
    async fetchProduct(handle) {
      const url = new URL(`${this.root}products/${encodeURIComponent(handle)}`,location.origin);
      url.searchParams.set('view','ea-wishlist-data');
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if(preview) url.searchParams.set('preview_theme_id',preview);
      const response=await fetch(url,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000)});
      if(response.status===404) return null;
      if(!response.ok) throw new Error('product');
      let product;
      try { product=JSON.parse(await response.text()); } catch(_) {
        if(!new URL(response.url).pathname.includes('/products/')) return null;
        throw new Error('product');
      }
      if(product.unavailable || product.handle!==handle || !Array.isArray(product.variants)) return null;
      return product;
    }
    async render() {
      const generation=++this.generation;
      this.products.clear(); this.content.replaceChildren(); this.sync();
      if(!this.items.length) {
        this.content.innerHTML=`<div class="ea-wish-empty"><svg class="ea-wish-art" viewBox="0 0 160 160" fill="none" aria-hidden="true"><ellipse cx="80" cy="81" rx="48" ry="66" stroke="currentColor" stroke-width=".6"/><ellipse cx="80" cy="81" rx="65" ry="47" stroke="currentColor" stroke-width=".6" transform="rotate(-35 80 81)"/><path d="M80 108 55 84c-20-20 9-40 25-20 16-20 45 0 25 20Z" stroke="currentColor" stroke-width="1.2"/><path d="m123 27 2 7 7 2-7 2-2 7-2-7-7-2 7-2Zm-86 91 1.5 5 5 1.5-5 1.5-1.5 5-1.5-5-5-1.5 5-1.5Z" fill="currentColor"/><circle cx="55" cy="20" r="2" fill="currentColor"/></svg><h3>${this.escape(this.text.empty_title)}</h3><p>${this.escape(this.text.empty_copy)}</p><a class="ea-wish-primary" href="${this.root}collections/new-arrivals">${this.escape(this.text.explore)}</a></div>`;
        return;
      }
      const handles=[...this.items];
      handles.forEach(handle=>{const row=document.createElement('article');row.className='ea-wish-row';row.dataset.handle=handle;row.setAttribute('aria-label',this.text.loading_title);row.innerHTML='<div class="ea-wish-skeleton" aria-hidden="true"></div>';this.content.append(row);});
      let cursor=0;
      const worker=async()=>{while(cursor<handles.length){const handle=handles[cursor++];let product,error=false;try{product=await this.fetchProduct(handle);}catch(_){error=true;}if(generation!==this.generation)return;const row=[...this.content.children].find(el=>el.dataset.handle===handle);if(!row)continue;row.removeAttribute('aria-label');if(error||!product){this.unavailable(row,error);continue;}this.products.set(handle,product);this.row(row,product);}};
      await Promise.all(Array.from({length:Math.min(4,handles.length)},worker));
    }
    unavailable(row,error) {
      row.className='ea-wish-unavailable';
      row.innerHTML=`<p>${this.escape(this.text[error?'error':'unavailable'])}</p>${error?`<button type="button" class="ea-wish-primary" data-wish-retry>${this.escape(this.text.retry)}</button> `:''}<button type="button" class="ea-wish-remove" data-wish-remove>${this.escape(this.text.remove)}</button>`;
    }
    money(cents,currency) {
      const code=currency||this.dataset.currency||'CAD';
      try {return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:code,currencyDisplay:'narrowSymbol'}).format(cents/100)+' '+code;} catch(_){return (cents/100).toFixed(2)+' '+code;}
    }
    price(product,variant) {
      const price=variant?variant.price:product.price;
      const compare=variant?.compare_at_price;
      return `${compare>price?`<s>${this.escape(this.money(compare,product.currency))}</s>`:''}${!variant&&product.price_varies?this.escape(this.text.from_price)+' ':''}${this.escape(this.money(price,product.currency))}`;
    }
    row(row,product) {
      const variant=product.default_only?product.variants[0]:null;
      const usable=product.available;
      const link=this.safeUrl(product.url);
      row.className='ea-wish-row';
      row.innerHTML=`<div class="ea-wish-product"><a class="ea-wish-photo" href="${link}" aria-label="${this.escape(product.title)}">${product.image?`<img src="${this.safeImage(product.image)}" width="256" height="320" loading="lazy" alt="${this.escape(product.title)}">`:''}</a><div class="ea-wish-info"><h3><a href="${link}">${this.escape(product.title)}</a></h3><p class="ea-wish-price" data-wish-price>${this.price(product,variant)}</p><div class="ea-wish-actions">${product.selling_plan_required?`<a class="ea-wish-primary" href="${link}">${this.escape(this.text.view_product)}</a>`:`<button type="button" class="ea-wish-primary" data-wish-main ${!usable?'disabled':''} ${!variant&&usable?'aria-expanded="false"':''}>${this.escape(this.text[!usable?'sold_out':variant?'add':'choose'])}${!variant&&usable?'<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" aria-hidden="true"><path d="m4 6 4 4 4-4"/></svg>':''}</button>`}<button type="button" class="ea-wish-remove" data-wish-remove aria-label="${this.escape(this.text.remove_label+': '+product.title)}">${this.escape(this.text.remove)}</button></div><a class="ea-wish-details" href="${link}">${this.escape(this.text.details)}</a></div></div><div class="ea-wish-options" data-wish-options hidden></div><p class="ea-wish-status" data-wish-status role="status" aria-live="polite"></p>`;
      if(variant) row.dataset.variant=variant.id;
    }
    choose(row,product) {
      const panel=row.querySelector('[data-wish-options]');const button=row.querySelector('[data-wish-main]');
      if(!panel.hidden) {panel.hidden=true;button.setAttribute('aria-expanded','false');return;}
      panel.hidden=false;button.setAttribute('aria-expanded','true');
      if(!panel.childElementCount){
        const id=`wish-${product.handle}`;
        panel.innerHTML=`<label for="${id}">${this.escape(product.options.join(' / '))}</label><select id="${id}" data-wish-select><option value="">${this.escape(this.text.select)}</option>${product.variants.map(v=>`<option value="${v.id}" ${v.available?'':'disabled'}>${this.escape(v.title)}${v.available?'':' — '+this.escape(this.text.sold_out)}</option>`).join('')}</select><button type="button" class="ea-wish-primary" data-wish-add hidden>${this.escape(this.text.add)}</button>`;
      }
      panel.querySelector('select').focus({preventScroll:true});
    }
    select(select) {
      const row=select.closest('[data-handle]'),product=this.products.get(row.dataset.handle),variant=product.variants.find(v=>String(v.id)===select.value);
      const button=row.querySelector('[data-wish-add]');button.hidden=!variant;button.disabled=!variant?.available;
      if(variant){row.dataset.variant=variant.id;row.querySelector('[data-wish-price]').innerHTML=this.price(product,variant);const image=row.querySelector('img');if(image&&variant.featured_image?.src)image.src=new URL(variant.featured_image.src,location.origin).href;}
      else{delete row.dataset.variant;row.querySelector('[data-wish-price]').innerHTML=this.price(product);}
      row.querySelector('[data-wish-status]').textContent='';
    }
    async add(row,button) {
      if(row.dataset.busy==='true')return;
      row.dataset.busy='true';button.disabled=true;button.textContent=this.text.adding;
      const status=row.querySelector('[data-wish-status]');status.classList.remove('is-error');status.textContent='';
      try {
        const product=await this.fetchProduct(row.dataset.handle);
        const variant=product?.variants.find(v=>String(v.id)===row.dataset.variant);
        if(!product || !variant?.available)throw new Error(this.text[!product?'unavailable':'sold_out']);
        if(product.selling_plan_required)throw new Error(this.text.view_product);
        row.querySelector('[data-wish-price]').innerHTML=this.price(product,variant);
        const response=await fetch(`${this.root}cart/add.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
        const result=await response.json();
        if(!response.ok||result.status)throw new Error(typeof result.description==='string'?result.description:this.text.cart_error);
        this.updateBag(result.sections);
        status.textContent=this.text.added+' ';
        const view=document.createElement('button');view.type='button';view.className='ea-wish-bag-link';view.dataset.wishBag='';view.textContent=this.text.bag;status.append(view);
        button.textContent=this.text.added;
        setTimeout(()=>{if(button.isConnected){button.textContent=this.text.add;button.disabled=false;}},1600);
      } catch(error) {status.classList.add('is-error');status.textContent=error.message==='product'?this.text.cart_error:error.message||this.text.cart_error;button.disabled=false;button.textContent=this.text.add;}
      finally{delete row.dataset.busy;}
    }
    updateBag(sections) {
      const parser=new DOMParser();
      if(sections?.['cart-icon-bubble']){const html=parser.parseFromString(sections['cart-icon-bubble'],'text/html');const current=document.getElementById('cart-icon-bubble');const content=html.querySelector('.shopify-section');if(current&&content)current.innerHTML=content.innerHTML;}
      if(sections?.['cart-drawer']){const html=parser.parseFromString(sections['cart-drawer'],'text/html');const next=html.querySelector('#CartDrawer'),current=document.getElementById('CartDrawer');if(next&&current){current.innerHTML=next.innerHTML;const drawer=current.closest('cart-drawer');drawer?.classList.remove('is-empty');current.querySelector('#CartDrawer-Overlay')?.addEventListener('click',()=>drawer?.close());}}
      if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'earthly-wishlist'});
    }
    click(event) {
      const target=event.target.closest('button');if(!target)return;
      if(target.matches('[data-wish-close]')){this.close();return;}
      if(target.matches('[data-wish-toast-close]')){this.toast.hidden=true;return;}
      if(target.matches('[data-wish-toast-action]')){this.toast.hidden=true;this.toastAction?.();return;}
      if(target.matches('[data-wish-bag]')){this.close();const bag=document.getElementById('cart-icon-bubble');if(bag)bag.click();else location.href=`${this.root}cart`;return;}
      const row=target.closest('[data-handle]');if(!row)return;
      if(target.matches('[data-wish-remove]')){this.remove(row.dataset.handle);return;}
      if(target.matches('[data-wish-retry]')){this.render();return;}
      const product=this.products.get(row.dataset.handle);if(!product)return;
      if(target.matches('[data-wish-main]')){if(product.default_only)this.add(row,target);else this.choose(row,product);}
      if(target.matches('[data-wish-add]'))this.add(row,target);
    }
    escape(value) {return String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
    safeUrl(value) {try{const url=new URL(value,location.origin);return url.origin===location.origin?this.escape(url.pathname+url.search):'#';}catch(_){return '#';}}
    safeImage(value) {try{const url=new URL(value,location.origin);if(url.protocol!=='https:')return '';url.searchParams.set('width','360');return this.escape(url.href);}catch(_){return '';}}
  }
  customElements.define('ea-wishlist',EarthlyWishlist);
})();
